import KnowledgeHub from "./knowledgeHub";

export default KnowledgeHub;
